import { Event } from "@checkout/events";
import { GenericChildState, type ChildMachineConfig } from "@checkout/types";
import { merge } from "lodash-es";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";

export const getMachineState = (config: ChildMachineConfig) => ({
  always: {
    actions: ActionTypes.setReviewVisited,
    cond: GuardTypes.notVisitedReview,
  },
  states: merge(
    {
      [GenericChildState.loading]: {},
      [GenericChildState.idle]: {},
    },
    config.stateOverride
  ),
  on: {
    [Event.PREVIOUS]: config.previousState,
    [Event.NEXT]: config.nextState,
  },
});
